import { memo, SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <rect width={32} height={32} fill="url(#a)" rx={16} />
      <path
        fill="#fff"
        d="M16 26c-5.523 0-10-4.477-10-10S10.477 6 16 6s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16.001A8 8 0 0 0 16 24Zm-1-5h2v2h-2v-2Zm2-1.645V18h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.5 3.5 0 1 1 17 17.355Z"
        opacity={0.9}
      />
      <defs>
        <linearGradient id="a" x1={16} x2={16} y1={0} y2={32} gradientUnits="userSpaceOnUse">
          <stop offset={0.274} stopColor="#490C97" />
          <stop offset={0.962} stopColor="#2B83F7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const Memo = memo(SvgComponent);
export { Memo as QuestionMarkIcon };
